import React from 'react';
import {useLocation} from 'react-router-dom';

import Navigation from './Navigation'

import {Container} from 'react-bootstrap';

import './Footer.scss'

const Footer = () => {
    const pathname = useLocation().pathname;

    // -----------------------------------------------------------------------------------------------------------------

    const pathnameAllowed = ['/', '/map', '/getting-here', '/services', '/more']

    // -----------------------------------------------------------------------------------------------------------------

    return (
        pathnameAllowed.includes(pathname) && (
            <footer id="footer" className="fixed-bottom">
                <Container fluid="lg" className="px-0">
                    <Navigation/>
                </Container>
            </footer>
        )
    )
}

export default Footer;